module.exports = __webpack_public_path__ + "static/media/For-Those-You-Love-Web-2.37908b30.jpg";